import { useState, useEffect } from "react";
import { Checkbox, CheckboxChangeEvent, TextBox, TextBoxChangeEvent } from "@progress/kendo-react-inputs";
import { Button } from "@progress/kendo-react-buttons";

interface EmailToListProps {
    intialList: string,
    setEmailList: Function,
    locked: boolean,
    newKit?: boolean,
    children?: React.ReactNode
}

const PrimaryLabContact_EmailFlag = "[PrimaryContactEmail]";
const Operator_EmailFlag = "[OperatorEmail]";

export const EmailReportToList = (props: EmailToListProps) => {
    const splitIntialList = props.intialList.split(",");
    const _emailToPrimaryContactIndex = splitIntialList.findIndex(x => x === PrimaryLabContact_EmailFlag);
    const _emailToOperatorIndex = splitIntialList.findIndex(x => x === Operator_EmailFlag);

    const [emailToPrimaryContact, _setEmailToPrimaryContact] = useState(_emailToPrimaryContactIndex != -1 || props.intialList.length === 0);
    const [emailToOperator, _setEmailToOperator] = useState(_emailToOperatorIndex != -1);

    if (_emailToPrimaryContactIndex != -1) {
        splitIntialList.splice(_emailToPrimaryContactIndex, 1)
        if (_emailToOperatorIndex != -1) {
            splitIntialList.splice(_emailToOperatorIndex - 1, 1)
        }
    } else if (_emailToOperatorIndex != -1) {
        splitIntialList.splice(_emailToOperatorIndex, 1)
    }

    const [emails, _setEmails] = useState(splitIntialList);

    const setEmailToPrimaryContact = (e: CheckboxChangeEvent) => {
        _setEmailToPrimaryContact(e.value);
    }
    const setEmailToOperator = (e: CheckboxChangeEvent) => {
        _setEmailToOperator(e.value);
    }

    const getSetEmail = (index: number) => {
        return (e: TextBoxChangeEvent) => {
            let changeArray = [...emails];
            changeArray[index] = e.value as string;
            _setEmails(changeArray);
        }
    }

    const addEmailToEmailList = () => {
        _setEmails([...emails, ""]);
    }
    const removeEmailToEmailList = (index: number) => {
        if (props.locked) return;
        var mutArray = [...emails];
        mutArray.splice(index, 1)
        _setEmails(mutArray);
    }

    useEffect(() => {
        let emailList = "";
        if (emailToPrimaryContact) {
            emailList += PrimaryLabContact_EmailFlag + ","
        }
        if (emailToOperator) {
            emailList += Operator_EmailFlag + ","
        }

        emails.forEach((e) => {
            if (e) {
                emailList += e + ",";
            }
        });

        if (emailList.length > 0) {
            //Removes the last comma from the lsit
            props.setEmailList(emailList.substring(0, emailList.length - 1));
        } else {
            props.setEmailList("");
        }
    }, [emails, emailToPrimaryContact, emailToOperator]);

    return <div style={{ width: "400px" }} className="s-k-flex-50 p-4 rounded-lg streck-secondary">
        {!props.newKit &&
            <>
                <i>
                    {props.locked ?
                        "This kit is locked, and so you willl not be able to make changes to the email list" :
                        "You will need to click 'Save Changes' in order for these changes to take effect."}
                </i>

                <br></br>
                <br></br>
            </>}

        <div style={{ marginBottom: "10px" }}>
            <Checkbox disabled={props.locked} value={emailToPrimaryContact} onChange={setEmailToPrimaryContact}></Checkbox> &nbsp;
            Email to Lab's Primary Contact
        </div>
        <div style={{ marginBottom: "10px" }}>
            <Checkbox disabled={props.locked} value={emailToOperator} onChange={setEmailToOperator}></Checkbox> &nbsp;
            Email to this Kit's Operator
        </div>
        <div>
            <div style={{ marginBottom: "10px" }}>
                Email To List:
            </div>
            {emails.map((_email, index) => (
                <span style={{ marginBottom: "3px", marginLeft: "10px", display: "inline-block" }}>
                    <span style={{ width: "300px", display: "inherit" }}>
                        <TextBox disabled={props.locked} value={_email} onChange={getSetEmail(index)}></TextBox>
                    </span>
                    <span className="k-icon k-i-x" onClick={() => removeEmailToEmailList(index)} />
                </span>
            ))}
            <br></br>
            <Button disabled={props.locked} onClick={() => addEmailToEmailList()}>Add Email</Button>
        </div>
    </div>;
}